import TransactionListTable from "./table";

const TransactionList = () => {
  return <TransactionListTable />;
};

export default TransactionList;
